import React from 'react';
import Box from 'apollo-react/components/Box';

const FieldErrorMessage = ({ error, severity = 'error', showIcon = true, sx = {}, ...props }) => {
  if (!error) return null;
  
  const colors = {
    error: '#d32f2f',
    warning: '#ed6c02',
    info: '#0288d1'
  };

  const color = colors[severity] || colors.error;
  
  return (
    <Box
      sx={{
        color,
        fontSize: '12px',
        marginTop: 1,
        marginBottom: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        lineHeight: 1.4,
        ...sx
      }}
      {...props}
    >
      {showIcon && <span style={{ color, flexShrink: 0 }}>⚠</span>}
      <span>{error}</span>
    </Box>
  );
};

export default FieldErrorMessage;
